import axios, { AxiosError } from 'axios';
import { FIlE_ATTACH_API_URL_DOWNLOAD } from '../../const/const';

interface DownloadAttachedFileData {
    UID: string;
}
export const DownloadAttachedFile = async (
    SmartDVRToken: string,
    userLogin: string,
    fileKey: string,
    fileName: string,
) => {
    if (!userLogin || !SmartDVRToken) {
        console.error('User information is missing.');
        return;
    }

    try {
        const response = await axios.get(FIlE_ATTACH_API_URL_DOWNLOAD(fileKey), {
            headers: {
                SmartDVRLogin: userLogin,
                SmartDVRToken: SmartDVRToken,
            },
            responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // Устанавливаем имя файла
        document.body.appendChild(link);
        link.click();

        // Очищаем память
        link.remove();
        window.URL.revokeObjectURL(url);
        // console.log(response);
        return true;
    } catch (error) {
        const err = error as AxiosError;
        console.error('Error delete AttachedFile:', err.response?.status, err.response?.data);
        return;
    }
};
